var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarRatings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 25,
    viewBox: "0 0 146 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0L15.3064 8.63729H24.3882L17.0409 13.9754L19.8473 22.6127L12.5 17.2746L5.15268 22.6127L7.95911 13.9754L0.611794 8.63729H9.69357L12.5 0Z",
    fill: "#FFC700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43 0L45.6942 8.63729H54.4127L47.3593 13.9754L50.0534 22.6127L43 17.2746L35.9466 22.6127L38.6407 13.9754L31.5873 8.63729H40.3058L43 0Z",
    fill: "#FFC700"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5 0L76.3064 8.63729H85.3882L78.0409 13.9754L80.8473 22.6127L73.5 17.2746L66.1527 22.6127L68.9591 13.9754L61.6118 8.63729H70.6936L73.5 0Z",
    fill: "#FFC700"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103 0L105.694 8.63729H114.413L107.359 13.9754L110.053 22.6127L103 17.2746L95.9466 22.6127L98.6407 13.9754L91.5873 8.63729H100.306L103 0Z",
    fill: "#FFC700"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M133.5 0L136.306 8.63729H145.388L138.041 13.9754L140.847 22.6127L133.5 17.2746L126.153 22.6127L128.959 13.9754L121.612 8.63729H130.694L133.5 0Z",
    fill: "#FFC700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarRatings);
export default __webpack_public_path__ + "static/media/Star_ratings.d3ec65f2bbee584c590fdd97d972d202.svg";
export { ForwardRef as ReactComponent };